import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import DisplayPage from "../components/DisplayPage.vue";
import AuthenticationPage from "../components/AuthenticationPage.vue";

const routes = [
    {
        path: '/auth',
        name: 'Auth',
        component: AuthenticationPage
    },
    {
        path: '/:id',
        name: 'Page',
        component: DisplayPage,
    },
    {
        path: '/',
        name: 'Home',
        component: DisplayPage,
    }
]

const resolveRouterHistory = () => {
    if (typeof window === "undefined") {
        return createWebHistory();
    }

    const protocol = window.location.protocol;
    const supportsHistory = protocol === "http:" || protocol === "https:";

    return supportsHistory ? createWebHistory() : createWebHashHistory();
};

const router = createRouter({
    history: resolveRouterHistory(),
    routes,
})

export default router
